import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { isArrayLike } from 'mobx';
import isPlainObject from 'lodash/isPlainObject';
import isNil from 'lodash/isNil';
import { getConfig } from 'choerodon-ui/lib/configure';
import { getTooltip, getTooltipTheme } from 'choerodon-ui/lib/_util/TooltipUtils';
import { FormField } from '../field/FormField';
import autobind from '../_util/autobind';
import { Tooltip as TextTooltip } from '../core/enum';
import { processFieldValue, renderMultiLine, toRangeValue } from '../field/utils';
import isEmpty from '../_util/isEmpty';
import isOverflow from '../overflow-tip/util';
import { show } from '../tooltip/singleton';
import { defaultOutputRenderer } from './utils';
let Output = class Output extends FormField {
    isEditable() {
        return false;
    }
    useFocusedClassName() {
        return false;
    }
    handleChange() {
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'name',
            'renderEmpty',
        ]);
    }
    getOtherPropsExcludeOutput(otherProps) {
        return otherProps;
    }
    getWrapperClassNamesExcludeOutput() {
        return undefined;
    }
    getObservablePropsExcludeOutput() {
        return undefined;
    }
    getValueKey(value) {
        if (isArrayLike(value)) {
            return value.map(this.getValueKey, this).join(',');
        }
        return this.processValue(value);
    }
    processValue(value) {
        if (!isNil(value)) {
            const text = isPlainObject(value) ? value : super.processValue(value);
            const { field } = this;
            return processFieldValue(text, field, {
                getProp: (name) => this.getProp(name),
                getValue: () => this.getValue(),
                lang: this.lang,
            }, true);
        }
        return '';
    }
    defaultRenderer(renderProps) {
        return defaultOutputRenderer(renderProps);
    }
    /**
     * 多行单元格渲染
     */
    renderMultiLine(field) {
        const { name, record, dataSet, prefixCls, props: { renderer }, } = this;
        const { lines, multipleValidateMessageLength } = renderMultiLine({
            name,
            field,
            record,
            dataSet,
            prefixCls,
            renderer,
            renderValidationResult: this.renderValidationResult,
            isValidationMessageHidden: this.isValidationMessageHidden,
            processValue: this.processValue.bind(this),
            tooltip: this.props.tooltip,
            labelTooltip: this.labelTooltip,
        });
        this.multipleValidateMessageLength = multipleValidateMessageLength;
        return lines;
    }
    getRenderedValue() {
        if (this.multiple) {
            return this.renderMultipleValues(true);
        }
        if (this.range) {
            return this.renderRangeValue(toRangeValue(this.getValue(), this.range));
        }
        /**
         * 多行单元格渲染
         */
        const { field } = this;
        if (field && field.get('multiLine')) {
            return this.renderMultiLine(field);
        }
        return this.processRenderer(this.getValue());
    }
    showTooltip(e) {
        if (super.showTooltip(e)) {
            return true;
        }
        const { tooltip = getTooltip('output') } = this.props;
        const { element, field } = this;
        if (element && !(field && field.get('multiLine')) && (tooltip === TextTooltip.always || (tooltip === TextTooltip.overflow && isOverflow(element)))) {
            const title = this.getRenderedValue();
            if (title) {
                show(element, {
                    title,
                    placement: 'right',
                    theme: getTooltipTheme('output'),
                });
                return true;
            }
        }
        return false;
    }
    renderWrapper() {
        const result = this.getRenderedValue();
        const { renderEmpty } = this.props;
        const text = isEmpty(result) || (isArrayLike(result) && !result.length) ? renderEmpty ? renderEmpty() : getConfig('renderEmpty')('Output') : result;
        return React.createElement("span", Object.assign({}, this.getMergedProps()), text);
    }
};
Output.displayName = 'Output';
Output.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'output',
};
__decorate([
    autobind
], Output.prototype, "handleChange", null);
__decorate([
    autobind
], Output.prototype, "getValueKey", null);
__decorate([
    autobind
], Output.prototype, "defaultRenderer", null);
Output = __decorate([
    observer
], Output);
export default Output;
